import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "main-forecast" }
const _hoisted_2 = {
  colspan: "2",
  class: "separator center"
}
const _hoisted_3 = {
  colspan: "2",
  class: "separator center"
}
const _hoisted_4 = {
  colspan: "2",
  class: "separator center"
}
const _hoisted_5 = { class: "separator price" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = { class: "separator price" }
const _hoisted_8 = { class: "price" }
const _hoisted_9 = { class: "separator price" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "separator price" }
const _hoisted_13 = { class: "price" }
const _hoisted_14 = { class: "separator price" }
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "separator price" }
const _hoisted_17 = { class: "price" }

import HeaderBlock from "@/components/HeaderBlock.vue";
import MainContentBase from "@/components/layout/MainContentBase.vue";
import { useQuery } from "@vue/apollo-composable";
import { EmployeesLoggedTimeResponse } from "@/helpers/user/typesDefinition";
import { GET_EMPLOYEES_LOGGED_TIME } from "@/graphql/user/queries";
import dayjs from "dayjs";
import { computed } from "vue";
import { LoggedHours } from "@/helpers/project/typesDefinition";
import enUK from "@/locales/home/en-UK.json";
import { useI18n } from "vue-i18n";
import { formatMonthDate } from "@/helpers/order/utils";
import { formatFloat, formatPercentage, formatPrice } from "@/helpers/utils";

type MessageSchema = typeof enUK;


export default /*@__PURE__*/_defineComponent({
  __name: 'RevenueForecast',
  setup(__props) {

const { t } = useI18n<[MessageSchema], "en-UK">({
  useScope: "global",
  inheritLocale: true,
  messages: {
    "en-UK": enUK,
  },
});

const startDate1 = dayjs().startOf("month");
const endDate1 = startDate1.endOf("month");
const startDate2 = startDate1.add(1, "month");
const endDate2 = startDate2.endOf("month");
const startDate3 = startDate2.add(1, "month");
const endDate3 = startDate3.endOf("month");

const { result } = useQuery<EmployeesLoggedTimeResponse>(
  GET_EMPLOYEES_LOGGED_TIME,
  {
    startDate1: startDate1.format("YYYY-MM-DD"),
    yesterday: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
    today: dayjs().format("YYYY-MM-DD"),
    endDate1: endDate1.format("YYYY-MM-DD"),
    startDate2: startDate2.format("YYYY-MM-DD"),
    endDate2: endDate2.format("YYYY-MM-DD"),
    startDate3: startDate3.format("YYYY-MM-DD"),
    endDate3: endDate3.format("YYYY-MM-DD"),
  },
);

const employees = computed(
  () =>
    result.value?.users.map((e) => {
      console.log(`Hours for ${e.firstName}`);
      return {
        ...e,
        period1: {
          data: e.period1,
          revenue: revenueForPeriod(e.period1) + revenueForPeriod(e.past),
          workingHours: e.workingHours1,
          plannedHours:
            e.period1.reduce((acc, lh) => acc + lh.plannedHours, 0) +
            e.past.reduce((acc, lh) => acc + lh.loggedHours, 0),
        },
        period2: {
          data: e.period2,
          revenue: revenueForPeriod(e.period2),
          workingHours: e.workingHours2,
          plannedHours: e.period2.reduce((acc, lh) => acc + lh.plannedHours, 0),
        },
        period3: {
          data: e.period3,
          revenue: revenueForPeriod(e.period3),
          workingHours: e.workingHours3,
          plannedHours: e.period3.reduce((acc, lh) => acc + lh.plannedHours, 0),
        },
      };
    }),
);

const total = computed(
  () =>
    employees.value?.reduce(
      (acc, e) => ({
        period1: {
          revenue: acc.period1.revenue + e.period1.revenue,
          workingHours: acc.period1.workingHours + e.period1.workingHours,
          plannedHours: acc.period1.plannedHours + e.period1.plannedHours,
        },
        period2: {
          revenue: acc.period2.revenue + e.period2.revenue,
          workingHours: acc.period2.workingHours + e.period2.workingHours,
          plannedHours: acc.period2.plannedHours + e.period2.plannedHours,
        },
        period3: {
          revenue: acc.period3.revenue + e.period3.revenue,
          workingHours: acc.period3.workingHours + e.period3.workingHours,
          plannedHours: acc.period3.plannedHours + e.period3.plannedHours,
        },
      }),
      {
        period1: { revenue: 0, plannedHours: 0, workingHours: 0 },
        period2: { revenue: 0, plannedHours: 0, workingHours: 0 },
        period3: { revenue: 0, plannedHours: 0, workingHours: 0 },
      },
    ),
);

const revenueForPeriod = (period: LoggedHours[]): number => {
  return period.reduce((acc, lh) => {
    if (!lh.projectRole) return acc;
    if (lh.plannedHours > 0) {
      console.log(
        `In ${formatMonthDate(dayjs(lh.startDate))}: ${
          lh.plannedHours
        }h planned on ${lh.projectRole.project.name} at ${
          lh.projectRole.hourlyRate
        } cent/h`,
      );
    }
    if (lh.loggedHours > 0) {
      console.log(
        `In ${formatMonthDate(dayjs(lh.startDate))}: ${
          lh.loggedHours
        }h logged on ${lh.projectRole.project.name} at ${
          lh.projectRole.hourlyRate
        } cent/h`,
      );
    }
    return (
      acc +
      lh.projectRole.hourlyRate *
        ((lh.plannedHours ?? 0) + (lh.loggedHours ?? 0))
    );
  }, 0);
};

const formatTimeDifference = <
  T extends { plannedHours: number; workingHours: number },
>({
  plannedHours,
  workingHours,
}: T): string => {
  return `${formatFloat(plannedHours)} h / ${formatFloat(
    workingHours,
  )}h (${formatPercentage(plannedHours / workingHours)})`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainContentBase, null, {
    default: _withCtx(() => [
      _createVNode(HeaderBlock, { class: "header" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("titles.revenueForecast")), 1)
        ]),
        _: 1
      }),
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, _toDisplayString(_unref(t)("revenueForecast.headers.name")), 1),
          _createElementVNode("th", _hoisted_2, _toDisplayString(_unref(formatMonthDate)(_unref(startDate1))), 1),
          _createElementVNode("th", _hoisted_3, _toDisplayString(_unref(formatMonthDate)(_unref(startDate2))), 1),
          _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(formatMonthDate)(_unref(startDate3))), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employees.value, (employee) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: employee.id
          }, [
            _createElementVNode("td", null, _toDisplayString(employee.firstName), 1),
            _createElementVNode("td", _hoisted_5, _toDisplayString(formatTimeDifference(employee.period1)), 1),
            _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(formatPrice)(employee.period1.revenue)), 1),
            _createElementVNode("td", _hoisted_7, _toDisplayString(formatTimeDifference(employee.period2)), 1),
            _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatPrice)(employee.period2.revenue)), 1),
            _createElementVNode("td", _hoisted_9, _toDisplayString(formatTimeDifference(employee.period3)), 1),
            _createElementVNode("td", _hoisted_10, _toDisplayString(_unref(formatPrice)(employee.period3.revenue)), 1)
          ]))
        }), 128)),
        (total.value)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("th", null, _toDisplayString(_unref(t)("revenueForecast.headers.total")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(formatTimeDifference(total.value.period1)), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_unref(formatPrice)(total.value.period1.revenue)), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(formatTimeDifference(total.value.period2)), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_unref(formatPrice)(total.value.period2.revenue)), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(formatTimeDifference(total.value.period3)), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_unref(formatPrice)(total.value.period3.revenue)), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})